const CHECKOUT_AUTH_SESSION_KEY = 'gmma.checkoutAuthSession.v1';
const EXPIRY_SKEW_SECONDS = 60;
let memorySession: AuthSession | null = null;

export interface AuthSession {
  email: string;
  authToken: string;
  userId: string;
  expiresAt?: number;
}

function isUsableSession(session: AuthSession): boolean {
  if (!session.email || !session.authToken || !session.userId) return false;
  if (!session.expiresAt) return true;
  return session.expiresAt > Math.floor(Date.now() / 1000) + EXPIRY_SKEW_SECONDS;
}

export function loadAuthSession(): AuthSession | null {
  try {
    const raw = window.localStorage.getItem(CHECKOUT_AUTH_SESSION_KEY);
    if (raw) {
      const session = JSON.parse(raw) as AuthSession;
      if (!isUsableSession(session)) {
        clearAuthSession();
        return null;
      }
      memorySession = session;
      return session;
    }
  } catch {
    // Fall through to the in-memory copy. This keeps tests and private-storage
    // contexts usable while real browsers persist through refresh via localStorage.
  }
  if (!memorySession || !isUsableSession(memorySession)) return null;
  return memorySession;
}

export function saveAuthSession(session: AuthSession): void {
  memorySession = session;
  try {
    window.localStorage.setItem(CHECKOUT_AUTH_SESSION_KEY, JSON.stringify(session));
  } catch {
    // Storage can be unavailable in private browsing or embedded contexts.
  }
}

export function clearAuthSession(): void {
  memorySession = null;
  try {
    window.localStorage.removeItem(CHECKOUT_AUTH_SESSION_KEY);
  } catch {
    // Ignore storage failures; in-memory session state still clears.
  }
}
